import { TransformRuleFactory } from "../../models/transformation/factory/TransformRuleFactory";
import {
  Lowercase,
  LowercaseData,
} from "../../models/transformation/Lowercase";
import {
  Uppercase,
  UppercaseData,
} from "../../models/transformation/Uppercase";
import "../../styles/transformation/upperLowercaseEditor.css";
import { getTransformRuleTypeDisplayValue } from "../../types/transformation/TransformationRuleTypes";
import { Button } from "../buttons/Button";
import Icon from "../Icon";
import { InputGroup } from "../inputGroup/InputGroup";
import { Label } from "../inputGroup/Label";
import { TransformTypeLabel } from "../inputGroup/TransformTypeLabel";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { TTTransformDeleteRule } from "../tooltips/ConfigurationTooltips";
import { TransformRuleMatcherEditorChildProps } from "./TransformRuleEditor";

export { UpperLowerecaseEditor };

type Props =
  | TransformRuleMatcherEditorChildProps<Lowercase>
  | TransformRuleMatcherEditorChildProps<Uppercase>;

const UpperLowerecaseEditor = (props: Props) => {
  const rule = TransformRuleFactory.createRule(props.rule.toData()) as
    | Lowercase
    | Uppercase;
  if (props.display === "view") {
    return <Display rule={rule} />;
  }
  return <Editor {...props} rule={rule} />;
};

type DisplayProps = {
  rule: LowercaseData | UppercaseData;
};

const Display = (props: DisplayProps) => {
  // add Key
  const rule = props.rule;
  return (
    <div className={"transformRuleEditor upperLowercaseEditor"}>
      <span>{rule.position}</span>
      {/* edit Input Date Format value */}
      <InputGroup>
        <Label>{getTransformRuleTypeDisplayValue(rule.discriminator)}</Label>
        <input
          type={"text"}
          value={""}
          placeholder={
            (rule.discriminator === "T_UCASE" ? "Upper" : "Lower") +
            "case transformation"
          }
          disabled
        />
      </InputGroup>
    </div>
  );
};

type EditorProps = Omit<Props, "display" | "rule"> & {
  rule: Lowercase | Uppercase;
};
const Editor = (props: EditorProps) => {
  const rule = props.rule;
  return (
    <div className={"transformRuleEditor upperLowercaseEditor"}>
      <span>{rule.position}</span>

      {/* edit Find Pattern value */}
      <InputGroup button>
        {props.changedRuleType && (
          <TransformTypeLabel
            discriminator={rule.getDiscriminator()}
            onTypeChange={(type) =>
              props.changedRuleType!(
                TransformRuleFactory.changeRule(rule.toData(), type),
              )
            }
          >
            {getTransformRuleTypeDisplayValue(rule.getDiscriminator())}
          </TransformTypeLabel>
        )}
        {!props.changedRuleType && (
          <Label>
            {getTransformRuleTypeDisplayValue(rule.getDiscriminator())}
          </Label>
        )}

        <input
          type={"text"}
          value={""}
          placeholder={
            (rule.getDiscriminator() === "T_UCASE" ? "Upper" : "Lower") +
            "case transformation"
          }
          disabled
        />

        <AdvancedTooltip overflow short tooltipText={TTTransformDeleteRule}>
          {(tProps) => (
            <Button
              {...tProps}
              onClick={() =>
                // delete
                props.update(null)
              }
            >
              <Icon altText={""} icon={"trash"} />
            </Button>
          )}
        </AdvancedTooltip>
      </InputGroup>
    </div>
  );
};
